import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ResponseCatalog, RequestParams } from 'Models'
import {
	PartnerOneDayShortModel,
	PartnerOneDayModel,
	STATUS_PARTNER,
	PartnerOneDayUpdateModel,
	AllDocumentPartner,
} from 'Pages/partner'
import { Callback } from 'Src/types/utilTypes'
import { Id } from 'Src/types/aliases'
import { FileWithPreview } from 'LibNeo'

interface PartnersState {
	data: ResponseCatalog<PartnerOneDayShortModel>
	requestParams: RequestParams
	partner: PartnerOneDayModel
	isLoading: boolean
	documents: AllDocumentPartner
}

const initialState: PartnersState = {
	data: new ResponseCatalog<PartnerOneDayShortModel>(),
	requestParams: new RequestParams(),
	partner: null,
	isLoading: false,
	documents: null,
}

export namespace PartnersNS {
	export type GetAll = PayloadAction<{
		params?: RequestParams
		clear?: boolean
		callback?: Callback
	}>
	export type SetAll = PayloadAction<ResponseCatalog<PartnerOneDayShortModel>>
	export type SetRequestParams = PayloadAction<RequestParams>
	export type ClearAll = PayloadAction
	export type GetOne = PayloadAction<Id>
	export type SetOne = PayloadAction<PartnerOneDayModel>
	export type SetStatus = PayloadAction<{
		id: Id
		status: STATUS_PARTNER
		callback?: Callback
	}>
	export type SetIsLoading = PayloadAction<boolean>
	export type ClearOne = PayloadAction
	export type UpdateOne = PayloadAction<{
		id: Id
		data: PartnerOneDayUpdateModel
		callback?: Callback
	}>
	export type UpdateOneDay = PayloadAction<{
		id: Id
		data: PartnerOneDayUpdateModel
		callback?: Callback
	}>
	export type GetDocuments = PayloadAction<Id>
	export type SetDocuments = PayloadAction<AllDocumentPartner>
	export type PostFile = PayloadAction<{
		file: FileWithPreview
	}>
}

export const partnersSlice = createSlice({
	name: 'partners',
	initialState,
	reducers: {
		getAll: (state, action: PartnersNS.GetAll) => {},
		setAll: (state, action: PartnersNS.SetAll) => {
			state.data = action.payload
		},
		setRequestParams: (state, action: PartnersNS.SetRequestParams) => {
			state.requestParams = action.payload
		},
		clearAll: (state, action: PartnersNS.ClearAll) => {
			state.data = new ResponseCatalog<PartnerOneDayShortModel>()
			state.requestParams = new RequestParams()
		},
		getOne: (state, action: PartnersNS.GetOne) => {},
		setOne: (state, action: PartnersNS.SetOne) => {
			state.partner = action.payload
		},
		setStatus: (state, action: PartnersNS.SetStatus) => {},
		setIsLoading: (state, action: PartnersNS.SetIsLoading) => {
			state.isLoading = action.payload
		},
		clearOne: (state, action: PartnersNS.ClearOne) => {
			state.partner = null
		},
		updateOne: (state, action: PartnersNS.UpdateOne) => {},
		updateOneDay: (state, action: PartnersNS.UpdateOneDay) => {},
		getDocuments: (state, action: PartnersNS.GetDocuments) => {},
		setDocuments: (state, action: PartnersNS.SetDocuments) => {
			state.documents = action.payload
		},
		postFile: (state, action: PartnersNS.PostFile) => {},
	},
})
